<template>
  <div>
      <el-card class="box-card" v-loading="loadingUser">
            <div slot="header" class="clearfix">
                    <span><i class="el-icon-lock"></i> Security</span>
            </div>
            <el-form :model="form" ref="formAdmin" :rules="formRule" label-width="100px" label-position="top">
                <el-form-item
                    label="Please Select Admin"
                    prop="useruid"
                >
                    <el-select 
                        v-model="form.useruid" 
                        filterable 
                        placeholder="Select"
                        
                        >
                        <el-option
                        v-for="item in userAdmin"
                        :key="item.uid"
                        :label="item.fullname"
                        :value="item.uid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm()" :loading="submiting">Submit</el-button>
                </el-form-item>
            </el-form>
      </el-card>
  </div>
</template>

<script>
import {getUserByCompany, setSupervisor} from '@/api/user'
import {findObject, findObjectArray} from '@/utils'
export default {
    props: {
        companyUID: String,
    },
    data(){
        return {     
            loadingUser: false,
            submiting: false, 
            form:{
                useruid: "",
            },
            formRule:{
                useruid: [{ required: true, message: 'Admin user is required'},]
            },
            userAdmin: []
        }
    },
    methods:{
         getUserData(){
            this.loadingUser = true
            getUserByCompany(this.companyUID).then(({result, data}) =>{
                this.loadingUser = false
                if(result){
                    this.userAdmin = findObjectArray(data, "admin", "role")
                    let supervisor = findObject(this.userAdmin, 1, "supervisor")
                    if(supervisor){
                        this.form.useruid = supervisor.uid
                    }
                }
            })
        },
        submitForm(){
            this.$refs.formAdmin.validate((valid)=>{
                if(valid){
                    this.submiting = true
                    setSupervisor(this.form.useruid).then(({result}) =>{
                        this.submiting = false
                        if(result){
                            this.$notify({
                                title: 'Success',
                                message: `Set supervisor user successfully`,
                                type: 'success',
                                duration: 2000
                            });
                        }
                    })
                }
            });
        }
    },
    created(){
        this.getUserData()
    }
}
</script>

<style>

</style>